import axios from '@/api/config';
const examSettingRelation={
  getExamSettingRelationList(data){
    return axios.get(`${process.env.BASE_URL}/examSettingRelation/getExamSettingRelationList`,{params:data})
  }
}
export default examSettingRelation



// WEBPACK FOOTER //
// ./src/api/examSettingRelation.js